import * as z from "zod/v4";

const StationQueueItem_ = z.object({
  workOrderId: z.string(),
  flowId: z.string(),
  currentStepId: z.string(),
  currentStepTitle: z.string().nullable(),
  status: z.string(),
  triggerKind: z.string(),
  bomName: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  quantity: z.number().int(),
  createdAt: z.date(),
});
export const StationQueueItem: z.ZodType<StationQueueItem> = StationQueueItem_;
export interface StationQueueItem extends z.infer<typeof StationQueueItem_> {}

export const getStationQueue = {
  name: "getStationQueue" as const,
  input: z.object({ stationId: z.string() }),
  output: z.object({ items: z.array(StationQueueItem) }),
};
